import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/tenant/user/tenant.user.query.gql"
import type {
  TenantUserQuery,
  TenantUserQueryVariables,
} from "@/v2-backoffice-client/tenant/user/__types__/tenant.user.query"

type Options = QueryHookOptions<TenantUserQuery, TenantUserQueryVariables>

export function useTenantUserQuery(options?: Options) {
  return useQuery<TenantUserQuery, TenantUserQueryVariables>(query, options)
}
